import store from '@/store'
import router from '@/router'

export default function oldFunctionsModule() {
  const ticketsDownloadOld = (orderData, selectedTickets, update) => {
    update(true)

    const url = new URL(`/orders/${orderData.id}/tickets?token=${orderData.token}`, window.location)

    selectedTickets.forEach(id => {
      url.searchParams.append('seats[]', id)
    })
    // window.open(url.toString(), '_blank').focus()

    const a = document.createElement('a')
    a.href = url.toString()
    a.download = 'tickets.pdf'
    a.click()

    setTimeout(() => update(false), 3000)
  }
  const ticketsPrintOld = (orderData, selectedTickets, format) => {
    const url = new URL(`/orders/${orderData.id}/tickets?token=${orderData.token}&format=${format}`, window.location)

    selectedTickets.forEach(id => {
      url.searchParams.append('seats[]', id)
    })

    window.open(url.toString(), '_blank').print()
  }
  const sendEmailsOld = sendData => {
    const queryParams = {
      name: sendData.name, email: sendData.email, isAddLink: sendData.is_add_link, id: router.currentRoute.params.id,
    }

    return store.dispatch('api/sendEmails', { ...queryParams })
      .then(() => ({
        success: true,
        message: 'Отправлено',
      }))
      .catch(() => ({
        success: false,
        message: 'Не удалось отправить',
      }))
  }

  return {
    ticketsDownloadOld,
    ticketsPrintOld,
    sendEmailsOld,
  }
}
